import { render, staticRenderFns } from "./GeneralMedicineAttention.vue?vue&type=template&id=5d9426bd&"
import script from "./GeneralMedicineAttention.vue?vue&type=script&lang=js&"
export * from "./GeneralMedicineAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYTransition})
